const authorityAlls = {
	ADVERTISING_RETAIL_READ: "ADVERTISING_RETAIL_READ",
	ADVERTISING_RETAIL_WRITE: "ADVERTISING_RETAIL_WRITE",
	ADVERTISING_RETAIL_APPROVAL_READ: "ADVERTISING_RETAIL_APPROVAL_READ",
	ADVERTISING_RETAIL_APPROVAL_WRITE: "ADVERTISING_RETAIL_APPROVAL_WRITE",
	ANALYZER_RETAIL_READ: "ANALYZER_RETAIL_READ",
	ANALYZER_RETAIL_WRITE: "ANALYZER_RETAIL_WRITE",
	GOODS_CATEGORY_PROFESSIONAL_READ: "GOODS_CATEGORY_PROFESSIONAL_READ",
	GOODS_CATEGORY_PROFESSIONAL_WRITE: "GOODS_CATEGORY_PROFESSIONAL_WRITE",
	GOODS_CATEGORY_RETAIL_READ: "GOODS_CATEGORY_RETAIL_READ",
	GOODS_CATEGORY_RETAIL_WRITE: "GOODS_CATEGORY_RETAIL_WRITE",
	PRODUCT_RETAIL_READ: "PRODUCT_RETAIL_READ",
	PRODUCT_RETAIL_WRITE: "PRODUCT_RETAIL_WRITE",
	GOODS_PROFESSIONAL_WRITE: "GOODS_PROFESSIONAL_WRITE",
	GOODS_PROFESSIONAL_READ: "GOODS_PROFESSIONAL_READ",
	HEALTHY_HAIR_RETAIL_READ: "HEALTHY_HAIR_RETAIL_READ",
	HEALTHY_HAIR_RETAIL_WRITE: "HEALTHY_HAIR_RETAIL_WRITE",
	HEALTHY_HAIR_PROFESSIONAL_WRITE: "HEALTHY_HAIR_PROFESSIONAL_WRITE",
	HEALTHY_HAIR_PROFESSIONAL_READ: "HEALTHY_HAIR_PROFESSIONAL_READ",
	TAG_READ: "TAG_READ",
	TAG_WRITE: "TAG_WRITE",
	TAG_PROFESSIONAL_WRITE: "TAG_PROFESSIONAL_WRITE",
	TAG_PROFESSIONAL_READ: "TAG_PROFESSIONAL_READ",
	USER_READ: "USER_READ",
	USER_WRITE: "USER_WRITE",
	PERSONAL_USER_WRITE: "PERSONAL_USER_WRITE",
	ROLE_READ: "ROLE_READ",
	ROLE_WRITE: "ROLE_WRITE",
	AUTHORITY_READ: "AUTHORITY_READ",
	AUTHORITY_WRITE: "AUTHORITY_WRITE",
	ANALYZER_PROFESSIONAL_READ: "ANALYZER_PROFESSIONAL_READ",
	ANALYZER_PROFESSIONAL_WRITE: "ANALYZER_PROFESSIONAL_WRITE",
	ADVERTISING_APPROVAL_PROFESSIONAL_READ: "ADVERTISING_APPROVAL_PROFESSIONAL_READ",
	ADVERTISING_APPROVAL_PROFESSIONAL_WRITE: "ADVERTISING_APPROVAL_PROFESSIONAL_WRITE",
	ADVERTISING_PROFESSIONAL_WRITE: "ADVERTISING_PROFESSIONAL_WRITE",
	ADVERTISING_PROFESSIONAL_READ: "ADVERTISING_PROFESSIONAL_READ",
	CUSTOMERS_PROFESSIONAL_WRITE: "CUSTOMERS_PROFESSIONAL_WRITE",
	CUSTOMERS_PROFESSIONAL_READ: "CUSTOMERS_PROFESSIONAL_READ",
	STORE_WRITE:"STORE_WRITE",
	STORE_READ:"STORE_READ",
	CUSTOMER_WRITE:"CUSTOMER_WRITE",
	CUSTOMER_READ:"CUSTOMER_READ",
	SUMMARY_STATISTICS:"SUMMARY_STATISTICS",
	COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_WRITE:"COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_WRITE",
	COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_READ:"COMPREHENSIVE_DETECTION_RESULT_SORT_RETAIL_READ",
	SINGLE_PRODUCT_RECOMMENDATION_RETAIL_READ:"SINGLE_PRODUCT_RECOMMENDATION_RETAIL_READ",
	SINGLE_PRODUCT_RECOMMENDATION_RETAIL_WRITE:"SINGLE_PRODUCT_RECOMMENDATION_RETAIL_WRITE",
	COMPREHENSIVE_DETECTION_PRODUCT_RECOMMENDATION_RETAIL_WRITE:"COMPREHENSIVE_DETECTION_PRODUCT_RECOMMENDATION_RETAIL_WRITE",
	COMPREHENSIVE_DETECTION_PRODUCT_RECOMMENDATION_RETAIL_READ:"COMPREHENSIVE_DETECTION_PRODUCT_RECOMMENDATION_RETAIL_READ"
};
export default authorityAlls;
